import {
  deleteApplication,
  getApplicationRequestDetails,
  sendAsrApplication,
} from 'api/applicationRegistration';
import { QueryClient, useMutation, useQuery } from 'react-query';
import { getConceptsData } from 'api/applicationdata';
import { ApplicationData } from '__generated__/api';

async function getConcepts(commercialRelation: string | null): Promise<ApplicationData[]> {
  const applicationDataList = await getConceptsData(commercialRelation);
  return applicationDataList;
}

export function useQueryConcepts() {
  const commercialRelation = localStorage.getItem('commercialRelation');
  return useQuery(['concepts', commercialRelation], () => getConcepts(commercialRelation));
}

export function useQueryApplicationRequestDetails(id?: number) {
  const { status, error, isError, isFetching, data } = useQuery(
    ['application-request-details', id],
    () => (id ? getApplicationRequestDetails(id) : undefined),
    { enabled: !!id }
  );

  return {
    status,
    error,
    isError,
    isFetching,
    data,
  };
}

export function useMutationAsrApplication() {
  return useMutation((asrDetails: any) => sendAsrApplication(asrDetails));
}

export function useDeleteApplication(
  id: number | undefined,
  onSuccess: () => void,
  error: () => void
) {
  const queryClient = new QueryClient();
  return useMutation(() => deleteApplication(id), {
    onSuccess: async () => {
      onSuccess();
    },
    onError: () => {
      error();
    },
    onSettled: () => {
      queryClient.invalidateQueries(['applications']);
    },
  });
}
